// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pt7{
  text-align: justify;
  font-size: 16px;
  color: #212529;
  text-wrap: wrap;
  word-break: break-word;
  margin-bottom: 5px;
}
.main7{
  box-shadow: 5px 7px 15px 5px #b9b6b6;
  padding: 10px;
  padding-bottom: 0px;
}
.desc7{
  text-wrap: wrap !important;
  text-align: justify;
}
.jobtitle7 {
  display: inline-block; /* or display: block; */
}
.jobtitle7::first-letter{
  text-transform: uppercase !important;
}
.profile-container7{

  display: inline-block;
  width: 100%;
}
.contact-7{
  text-wrap: wrap;
  word-break: break-word;
}
.mainbox7 {
  flex-wrap: wrap;
  justify-content: flex-start;
}
.name7{
  letter-spacing: 0.1em;
  font-weight: bold;
  font-size: 28px;
  text-transform: uppercase;
  color: #e9ecef;
}
#header7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: black;
  color: white;
  margin-bottom: 20px;
}
#header7 > div {
  flex: 1 1; 
}
#header7 .contactdetail7 {
margin-left: 24px;
  font-size: 16px;
  margin-bottom: 54px;
  flex-direction: row; 
  gap: 15px;
}

#underline7 {
  width: 280px;
  height: 7px;
  margin-top: 20px;
  background-color: #CECED0;

}
.bold7{
  font-weight: bold;
}
.button-container7{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  padding: 0px 0rem 0 12rem;
  display: flex;
  }

.db7{
  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 5px;
  display: block;
  margin-left: 5.5rem;
}

.bk7{
  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 5px;
  display: block;
  margin-left: -1rem;
}
@media (max-width: 768px) {
  .db7{
    padding-top: 0px !important;
    margin-left: 0px !important;
  }
  .button-container7{
    padding: 0px;
  }
  .bk7{
    margin-left: 0rem !important;
  }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .db7{
      margin-left: 154px;
      text-wrap: nowrap;
   
    }
    .button-container7{
    
      margin-left: 0px;
      align-items: flex-start;
    }
    .bk7{
      margin-left: 0rem !important;
    }
   
  }

#web7 {
  letter-spacing: 0.2em;
  margin-top: 15px;
  font-size: 20px;
  text-transform: capitalize;
}
#exp7, #contact7, #skills7 {
  background: #CDCDCF;
  padding: 1px;
font-weight:500;
color: #212529;
}
#image7 {
  height: 150px;
  width: 150px;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 20px;
}
.skills7 {
  display: grid;
}

@media (max-width: 1200px) {
  .scroll-container7 {
    display: block;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .profile-container7 {
    min-width: 1036px;
  }
}

@media (max-width: 768px) {
 #header7 {
    grid-template-columns: 1fr;
  }

  #image7 {
    height: 120px;
    width: 120px;
  }

  .name7 {
    letter-spacing: 0.1em;
    font-weight: bold;
    font-size: 28px;
  }

  #web7 {
    font-size: 20px; 
    margin-top: 15px;
  }

  .skills7 {
    grid-template-columns: 1fr;
  }

  #exp7, #contact7, #skills7 {
    font-size: 16px;
    padding: 5px;
  }

  .profile-container7 {
    padding: 0 10px;
  }
  .contactdetail7 {
    flex-direction: column;
  }



}

@media (max-width: 1199px) {
  .profile-container7 {
    width: 100%;
  }
}

@media (max-width: 576px) {


  .name7 {
    letter-spacing: 0.1em;
    font-weight: bold;
    font-size: 28px;
  }

  #web7 {
    font-size: 20px;
    margin-top: 10px;
  }

  .pt7 {
    font-size: 16px;
  }

  .skills7 {
    grid-template-columns: 1fr;
  }


    .profile-container7 {
    padding: 0 10px;
  }
  .contactdetail7 {
    flex-direction: column;
  }
}
@media (max-width: 991px) {

.profile-container7 {
  flex-direction: column; 
  padding: 10px;
  gap: 10px;
}

.contactdetail7 {
  flex-direction: column;
  gap: 10px;
}
}
.scroll-container7 {
  overflow-x: auto;
  display: block;
  text-align: justify;
  text-wrap: wrap;
}



.footer7 {
  padding: 3px 0;
  margin-top: 20px;
  border-top: 1px solid #e9ecef;

}

.footer-text7 {
  font-size: 16px;
  color: #6c757d; 
  text-align: end;
  margin-right: 15px;
  margin-bottom: 2px;
}

.footer-link7 {
  color: #007bff; 
  text-decoration: none;
}
.contact-icon {
  font-size: 16px !important; /* Adjust the size as needed */

}

.github-profile-container {
  display: flex;
  align-items: top;
  margin-top: 1px;

}

.github-profile-text {
  margin-left: 10px;
  margin-top: 0;
  max-width: calc(100% - 30px);
  /* white-space: nowrap; */
  /* overflow: hidden; */
  text-overflow:ellipsis;
  text-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/Resume/Template/UseTemp7.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,qBAAqB,EAAE,uBAAuB;AAChD;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,SAAO;AACT;AACA;AACA,iBAAiB;EACf,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,yBAAyB;;AAE3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb;;AAEF;EACE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;;EAEA;IACE;MACE,kBAAkB;MAClB,iBAAiB;;IAEnB;IACA;;MAEE,gBAAgB;MAChB,uBAAuB;IACzB;IACA;MACE,4BAA4B;IAC9B;;EAEF;;AAEF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,YAAY;AACd,eAAe;AACf,cAAc;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,iCAAiC;EACnC;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;CACC;IACG,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;;;;AAIF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;;;EAGE;IACE,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;;IAGE;IACA,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;AACA;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;;;AAIA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;;AAE/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B,EAAE,8BAA8B;;AAE5D;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":["\r\n.pt7{\r\n  text-align: justify;\r\n  font-size: 16px;\r\n  color: #212529;\r\n  text-wrap: wrap;\r\n  word-break: break-word;\r\n  margin-bottom: 5px;\r\n}\r\n.main7{\r\n  box-shadow: 5px 7px 15px 5px #b9b6b6;\r\n  padding: 10px;\r\n  padding-bottom: 0px;\r\n}\r\n.desc7{\r\n  text-wrap: wrap !important;\r\n  text-align: justify;\r\n}\r\n.jobtitle7 {\r\n  display: inline-block; /* or display: block; */\r\n}\r\n.jobtitle7::first-letter{\r\n  text-transform: uppercase !important;\r\n}\r\n.profile-container7{\r\n\r\n  display: inline-block;\r\n  width: 100%;\r\n}\r\n.contact-7{\r\n  text-wrap: wrap;\r\n  word-break: break-word;\r\n}\r\n.mainbox7 {\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n}\r\n.name7{\r\n  letter-spacing: 0.1em;\r\n  font-weight: bold;\r\n  font-size: 28px;\r\n  text-transform: uppercase;\r\n  color: #e9ecef;\r\n}\r\n#header7 {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: black;\r\n  color: white;\r\n  margin-bottom: 20px;\r\n}\r\n#header7 > div {\r\n  flex: 1; \r\n}\r\n#header7 .contactdetail7 {\r\nmargin-left: 24px;\r\n  font-size: 16px;\r\n  margin-bottom: 54px;\r\n  flex-direction: row; \r\n  gap: 15px;\r\n}\r\n\r\n#underline7 {\r\n  width: 280px;\r\n  height: 7px;\r\n  margin-top: 20px;\r\n  background-color: #CECED0;\r\n\r\n}\r\n.bold7{\r\n  font-weight: bold;\r\n}\r\n.button-container7{\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 10px 0;\r\n  padding: 0px 0rem 0 12rem;\r\n  display: flex;\r\n  }\r\n\r\n.db7{\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 5px;\r\n  display: block;\r\n  margin-left: 5.5rem;\r\n}\r\n\r\n.bk7{\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 5px;\r\n  display: block;\r\n  margin-left: -1rem;\r\n}\r\n@media (max-width: 768px) {\r\n  .db7{\r\n    padding-top: 0px !important;\r\n    margin-left: 0px !important;\r\n  }\r\n  .button-container7{\r\n    padding: 0px;\r\n  }\r\n  .bk7{\r\n    margin-left: 0rem !important;\r\n  }\r\n  }\r\n\r\n  @media (min-width: 768px) and (max-width: 1024px) {\r\n    .db7{\r\n      margin-left: 154px;\r\n      text-wrap: nowrap;\r\n   \r\n    }\r\n    .button-container7{\r\n    \r\n      margin-left: 0px;\r\n      align-items: flex-start;\r\n    }\r\n    .bk7{\r\n      margin-left: 0rem !important;\r\n    }\r\n   \r\n  }\r\n\r\n#web7 {\r\n  letter-spacing: 0.2em;\r\n  margin-top: 15px;\r\n  font-size: 20px;\r\n  text-transform: capitalize;\r\n}\r\n#exp7, #contact7, #skills7 {\r\n  background: #CDCDCF;\r\n  padding: 1px;\r\nfont-weight:500;\r\ncolor: #212529;\r\n}\r\n#image7 {\r\n  height: 150px;\r\n  width: 150px;\r\n  margin-top: 20px;\r\n  margin-bottom: 20px;\r\n  margin-left: 20px;\r\n}\r\n.skills7 {\r\n  display: grid;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .scroll-container7 {\r\n    display: block;\r\n    overflow-x: scroll;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n  .profile-container7 {\r\n    min-width: 1036px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n #header7 {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  #image7 {\r\n    height: 120px;\r\n    width: 120px;\r\n  }\r\n\r\n  .name7 {\r\n    letter-spacing: 0.1em;\r\n    font-weight: bold;\r\n    font-size: 28px;\r\n  }\r\n\r\n  #web7 {\r\n    font-size: 20px; \r\n    margin-top: 15px;\r\n  }\r\n\r\n  .skills7 {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  #exp7, #contact7, #skills7 {\r\n    font-size: 16px;\r\n    padding: 5px;\r\n  }\r\n\r\n  .profile-container7 {\r\n    padding: 0 10px;\r\n  }\r\n  .contactdetail7 {\r\n    flex-direction: column;\r\n  }\r\n\r\n\r\n\r\n}\r\n\r\n@media (max-width: 1199px) {\r\n  .profile-container7 {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n\r\n\r\n  .name7 {\r\n    letter-spacing: 0.1em;\r\n    font-weight: bold;\r\n    font-size: 28px;\r\n  }\r\n\r\n  #web7 {\r\n    font-size: 20px;\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .pt7 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .skills7 {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n\r\n    .profile-container7 {\r\n    padding: 0 10px;\r\n  }\r\n  .contactdetail7 {\r\n    flex-direction: column;\r\n  }\r\n}\r\n@media (max-width: 991px) {\r\n\r\n.profile-container7 {\r\n  flex-direction: column; \r\n  padding: 10px;\r\n  gap: 10px;\r\n}\r\n\r\n.contactdetail7 {\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n}\r\n.scroll-container7 {\r\n  overflow-x: auto;\r\n  display: block;\r\n  text-align: justify;\r\n  text-wrap: wrap;\r\n}\r\n\r\n\r\n\r\n.footer7 {\r\n  padding: 3px 0;\r\n  margin-top: 20px;\r\n  border-top: 1px solid #e9ecef;\r\n\r\n}\r\n\r\n.footer-text7 {\r\n  font-size: 16px;\r\n  color: #6c757d; \r\n  text-align: end;\r\n  margin-right: 15px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.footer-link7 {\r\n  color: #007bff; \r\n  text-decoration: none;\r\n}\r\n.contact-icon {\r\n  font-size: 16px !important; /* Adjust the size as needed */\r\n\r\n}\r\n\r\n.github-profile-container {\r\n  display: flex;\r\n  align-items: top;\r\n  margin-top: 1px;\r\n\r\n}\r\n\r\n.github-profile-text {\r\n  margin-left: 10px;\r\n  margin-top: 0;\r\n  max-width: calc(100% - 30px);\r\n  /* white-space: nowrap; */\r\n  /* overflow: hidden; */\r\n  text-overflow:ellipsis;\r\n  text-wrap: wrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
